if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => { 
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
           
              
               
//                 (function () {


//   // ---------------------------------------------------------------
//   // Price formatter -> "349 kr" (no decimals, Danish thousands sep)
//   // ---------------------------------------------------------------
//   function formatDK(cents) {
//     if (!cents) return "0 kr";
//     var kr = Math.round(cents / 100);
//     var formatted = kr.toLocaleString('da-DK', {
//       minimumFractionDigits: 0,
//       maximumFractionDigits: 0
//     });
//     return formatted + " kr";
//   }

//   // ---------------------------------------------------------------
//   // Build responsive srcset from a single Shopify CDN image URL
//   // (Shopify CDN supports &width=xxx resizing on any cdn/shop file url)
//   // ---------------------------------------------------------------
//   function buildSrcset(imgUrl) {
//     if (!imgUrl) return { srcset: '', src: '' };
//     var widths = [165, 360, 533, 720, 940, 1066, 1500];
//     var hasQuery = imgUrl.includes('?');
//     var srcset = widths
//       .map(w => `${imgUrl}${hasQuery ? '&' : '?'}width=${w} ${w}w`)
//       .join(',');
//     var src = `${imgUrl}${hasQuery ? '&' : '?'}width=533`;
//     return { srcset, src };
//   }

//   // ---------------------------------------------------------------
//   // Render a single product as the theme's <li> card markup.
//   // - single variant  -> real add-to-cart <form action="/cart/add">
//   // - multiple variant -> modal-opener "Vælg muligheder" (quick add)
//   // ---------------------------------------------------------------
//   function renderProductLi(product) {
//     var { srcset, src } = buildSrcset(product.featured_image);
//     var uid = product.id; // unique-ish id suffix for aria/id attrs
//     var hasSale = product.compare_at_price > product.price;
//     var variantCount = product.variants ? product.variants.length : 1;
//     var firstVariantId = product.variants && product.variants[0]
//       ? product.variants[0].id
//       : product.variants_id;

//     var priceBlock = hasSale
//       ? `
//         <div class=" price price--on-sale">
//           <div class="price__container">
//             <div class="price__regular">
//               <span class="visually-hidden visually-hidden--inline">Normalpris</span>
//               <span class="price-item price-item--regular"> ${formatDK(product.price)} </span>
//             </div>
//             <div class="price__sale">
//               <span class="visually-hidden visually-hidden--inline">Normalpris</span>
//               <span> <s class="price-item price-item--regular"> ${formatDK(product.compare_at_price)} </s> </span>
//               <span class="visually-hidden visually-hidden--inline">Udsalgspris</span>
//               <span class="price-item price-item--sale price-item--last"> ${formatDK(product.price)} </span>
//             </div>
//           </div>
//         </div>`
//       : `
//         <div class=" price price--regular">
//           <div class="price__container">
//             <div class="price__regular">
//               <span class="price-item price-item--regular"> ${formatDK(product.price)} </span>
//             </div>
//           </div>
//         </div>`;

//     var badge = hasSale
//       ? `<div class="card__badge top left"><span class="badge badge--bottom-left color-scheme-4">Udsalg</span></div>`
//       : '';

//     // ---- Quick add area: single variant vs multiple variant ----
//     var quickAddBlock;
//     if (variantCount <= 1) {
//       quickAddBlock = `
//       <div class="quick-add no-js-hidden">
//         <product-form data-section-id="">
//           <form method="post" action="/cart/add" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
//             <input type="hidden" name="form_type" value="product" tabindex="-1">
//             <input type="hidden" name="utf8" value="&#10003;" tabindex="-1">
//             <input type="hidden" name="id" value="${firstVariantId}" class="product-variant-id" tabindex="-1">
//             <button type="submit" name="add" class="quick-add__submit button button--full-width button--secondary" aria-haspopup="dialog" data-sold-out-message="true">
//               <span>TILF&Oslash;J TIL KURV -</span>
//               <span class="pro-price"> ${formatDK(product.price)} </span>
//               <div class="loading__spinner hidden">
//                 <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
//                   <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
//                 </svg>
//               </div>
//             </button>
//             <input type="hidden" name="product-id" value="${uid}" tabindex="-1">
//           </form>
//         </product-form>
//       </div>`;
//     } else {
//       quickAddBlock = `
//       <div class="quick-add no-js-hidden">
//         <modal-opener data-modal="#QuickAdd-${uid}">
//           <button type="submit" name="add" class="quick-add__submit button button--full-width button--secondary" aria-haspopup="dialog" data-product-url="${product.url}">
//             V&aelig;lg muligheder -
//             <div class="loading__spinner hidden">
//               <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
//                 <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
//               </svg>
//             </div>
//             <span class="pro-price"> ${formatDK(product.price)} </span>
//           </button>
//         </modal-opener>
//       </div>`;
//     }

//     return `
//     <li class="grid__item scroll-trigger animate--slide-in" style="width: 100%; display: inline-block;">
//       <div class="card-wrapper product-card-wrapper underline-links-hover">
//         <div class="feature-img-btns overlay-badges enable_product_badges_new"></div>
//         <div class=" card card--standard card--media " style="--ratio-percent: 100%;">
//           <div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent: 100%;">
//             <div class="card__media_title">
//               <div class="media media--transparent media--hover-effect">
//                 <img srcset="${srcset}" src="${src}" alt="${product.title}" class="motion-reduce" loading="lazy" width="1500" height="1500">
//               </div>
//               <div class="pro-short-description-title-block">
//                 <h3 class="card__heading h5">
//                   <a href="${product.url}" class="full-unstyled-link" tabindex="-1"> ${product.title} </a>
//                 </h3>
//               </div>
//             </div>
//             <div class="card__content">
//               <div class="card__information">
//                 <h3 class="card__heading">
//                   <a href="${product.url}" class="full-unstyled-link" tabindex="-1"> ${product.title} </a>
//                 </h3>
//               </div>
//               ${badge}
//             </div>
//           </div>
//           <div class="card__content">
//             <div class="card__information">
//               <h3 class="card__heading h5">
//                 <a href="${product.url}" class="full-unstyled-link" tabindex="-1"> ${product.title} </a>
//               </h3>
//               <div class="card-information">
//                 <span class="caption-large light"></span>
//                 ${priceBlock}
//               </div>
//             </div>
//           </div>
//           ${quickAddBlock}
//         </div>
//       </div>
//     </li>`;
//   }

//   // ---------------------------------------------------------------
//   // Slick slider init (runs after every HTML append/re-render)
//   // ---------------------------------------------------------------
//   function initSlider() {
//     // jQuery/slick abhi tak load nahi hue -> chup-chap skip karo,
//     // list rendering pe koi asar nahi padega.
//     if (typeof $ === 'undefined' || !$.fn || !$.fn.slick) return;

//     var slider = $('.cart-rec-slider-inner');

//     if (!slider.length) return;

//     if (slider.hasClass('slick-initialized')) {
//       slider.slick('unslick');
//     }

//     slider.slick({
//       slidesToShow: 2,
//       slidesToScroll: 1,
//       arrows: false,
//       infinite: true,
//       dots: false,
//       centerMode: true,
//       centerPadding: '50px',
//       responsive: [
//         {
//           breakpoint: 767,
//           settings: {
//             slidesToShow: 1,
//           }
//         }
//       ]
//     });
//   }

//   // NOTE: native addEventListener delegation used here on purpose
//   // (instead of top-level $(document).on(...)) so this code never
//   // throws "$ is not defined" if jQuery loads AFTER this script.
//   // jQuery is only touched at click-time, by which point it's
//   // guaranteed to be loaded.
//   document.addEventListener('click', function (e) {
//     if (e.target.closest('.rec-next')) {
//       var slider = $('.cart-rec-slider-inner');
//       if (slider.hasClass('slick-initialized')) {
//         slider.slick('slickNext');
//       }
//     }
//     if (e.target.closest('.rec-prev')) {
//       var slider = $('.cart-rec-slider-inner');
//       if (slider.hasClass('slick-initialized')) {
//         slider.slick('slickPrev');
//       }
//     }
//   });

//   // ---------------------------------------------------------------
//   // Fetch cart -> get first product's id -> fetch recommendations
//   // -> render into .cart-reccom-items -> re-init slider
//   // ---------------------------------------------------------------
//   async function loadCartRecommendations() {
//     var container = document.querySelector('.cart-reccom-items');
//     if (!container) return;

//     try {
//       var cartRes = await fetch(window.Shopify.routes.root + 'cart.js', { cache: 'no-store' });
//       var cart = await cartRes.json();

//       if (!cart.items || cart.items.length === 0) {
//         container.innerHTML = '';
//         return;
//       }

//       var productId = cart.items[0].product_id;
//       var recRes = await fetch(
//         window.Shopify.routes.root + 'recommendations/products.json?product_id=' + productId + '&limit=4'
//       );
//       var data = await recRes.json();

//       if (!data.products || data.products.length === 0) {
//         container.innerHTML = '';
//         return;
//       }

//       container.innerHTML = data.products.map(renderProductLi).join('');

//       // Slider ko HTML append hone ke baad (re)init karo
//       initSlider();

//     } catch (e) {
//       console.log('Cart recommendations load error', e);
//     }
//   }



//   // ---------------------------------------------------------------
//   // Re-run recommendations when cart changes
//   // ---------------------------------------------------------------
//   var recReloadTimeout;

//   document.addEventListener('cart:refresh', function () {
//     clearTimeout(recReloadTimeout);
//     recReloadTimeout = setTimeout(loadCartRecommendations, 500);
//   });

//   document.addEventListener('click', function (e) {
//     if (e.target.closest('.quantity__button') || e.target.closest('cart-remove-button')) {
//       clearTimeout(recReloadTimeout);
//       recReloadTimeout = setTimeout(loadCartRecommendations, 2000);
//     }
//     if (e.target.closest('.product-form__submit')) {
//       setTimeout(loadCartRecommendations, 1500);
//     }
//   });

//   // Initial load
//   loadCartRecommendations(); 

// })();

    

       



     
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
